<template>
    <div>
        <v-container grid-md>
            <v-layout style="display: flex; flex-wrap: wrap">
                <v-flex
                    d-flex
                    class="login-box"
                >
                    <main>
                        <PageIntro
                            v-if="appLogin === false"
                            :heading="'Sign in below'
                                "
                            :body="'Sign in with email'"
                        />

                        <Login />
                    </main>
                </v-flex>
                <v-flex
                    d-flex
                    class="home-box"
                >
                    <div>
                        <!-- <PageIntro 
              :heading="'Don\'t have a digital membership yet?'"
              :body="'<p>Register now and become #PartOfThePride!</p>'+
              '<p>Here\'s some of what you get:</p>'+
              '<ul><li>Watch Pre & post-match news and highlights on VillaTV.</li>'+
              '<li>Listen to live match commentary.</li>'+
              '<li>Exclusive Villa competitions and polls.</li>'+
              '<li>Personalise your digital experience with the Club.</li>'+
              '<li>Access to the Pride Rewards loyalty scheme</li>'+
              '<li>Manage your ticketing account</li></ul></p>'"/> -->
                        <PageIntro
                            :heading="'Not an Essential Member yet?'"
                            :body="'<p>Register now and become a Villan</p>'"
                        />
                        <HomeRegister />
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
        <FooterShout
            v-if="appLogin === false"
            :type="'register'"
        />
    </div>
</template>

<script>
import Login from "@/components/Login";
import HomeRegister from "@/components/HomeRegister";
import PageIntro from "@/components/PageIntro";
import FooterShout from "@/components/FooterShout";

export default {
    components: {
        Login,
        HomeRegister,
        PageIntro,
        FooterShout,
    },
    data() {
        return {
            from: null,
            appLogin: false
        };
    },
    mounted() {
        // if they are coming from the app specific login URL adapt the page accordingly
        if (this.$router.currentRoute.name === "app-login") {
            this.appLogin = true;
        }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.from = from;

            // TODO: Make sure we handle people referred from password reset with a message on sign in page
        });
    },
};
</script>
<style lang="scss" scoped>
.login-box {
    width: 100%;

    @media screen and (min-width: 700px) {
        width: 50%;
    }
}

.home-box {
    width: 100%;

    @media screen and (min-width: 700px) {
        width: 50%;
    }
}
</style>
